'use client';

import React from 'react';
import { PolicyModalShell } from './PolicyModalShell';

interface PrivacyPolicyModalProps {
  alreadyAgreed?: boolean;
  isOpen: boolean;
  onAgree?: () => void;
  onClose: () => void;
}

export const PrivacyPolicyModal: React.FC<PrivacyPolicyModalProps> = ({ alreadyAgreed, isOpen, onAgree, onClose }) => {
  return (
    <PolicyModalShell alreadyAgreed={alreadyAgreed} isOpen={isOpen} onAgree={onAgree} onClose={onClose} title="개인정보처리방침">
      <p className="mb-4 text-[15px]">
        <b>한림기술</b>(이하 ‘회사’)은(는) 「개인정보 보호법」 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과
        같이 개인정보 처리방침을 수립·공개합니다.
      </p>

      <h3 className="mt-4 text-[20px] font-semibold">제1조 (개인정보의 처리 목적)</h3>
      <p className="mb-2">
        회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 「개인정보 보호법」
        제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
      </p>
      <ul className="list-[circle] space-y-1">
        <li>
          <span className="font-semibold">1. 회원 가입 및 관리</span>
          <br />
          <span className="ml-6 block">회원 가입 의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 각종 고지·통지, 고충처리</span>
        </li>
        <li>
          <span className="font-semibold">2. 재화 또는 서비스 제공</span>
          <br />
          <span className="ml-6 block">서비스 제공, 계약서·청구서 발송, 콘텐츠 제공, 맞춤형 서비스 제공, 요금결제·정산, 채권추심</span>
        </li>
        <li>
          <span className="font-semibold">3. 위치기반 서비스 제공</span>
          <br />
          <span className="ml-6 block">위치정보를 활용한 콘텐츠 제공 및 관제 서비스 (※ 세부 사항은 별도의 &apos;위치기반서비스 이용약관&apos;에 따름)</span>
        </li>
      </ul>

      <h3 className="mt-4 text-[20px] font-semibold">제2조 (처리하는 개인정보의 항목)</h3>
      <p className="mb-2">회사는 서비스 제공을 위해 필요한 최소한의 개인정보를 수집하고 있습니다.</p>
      <ul className="list-[circle] space-y-1">
        <li>
          <span className="font-semibold">1. 회원 가입 및 서비스 운영 (필수)</span>
          <br />
          <span className="ml-6 block">아이디(ID), 비밀번호, 이름, 휴대전화번호, 이메일, 생년월일, 회사명</span>
        </li>
        <li>
          <span className="font-semibold">2. 업무 처리를 위한 추가 정보 (선택)</span>
          <br />
          <span className="ml-6 block">부서명, 직책, 프로필 사진</span>
        </li>
        <li>
          <span className="font-semibold">3. 서비스 이용 과정에서 자동 수집 정보</span>
          <br />
          <span className="ml-6 block">
            단말기 정보(OS, 모델명), IP주소, 쿠키, 접속 로그, 서비스 이용 기록, 불량 이용 기록, (위치기반 서비스 이용 시) GPS, Wi-Fi, 기지국 기반의 위치 정보
          </span>
        </li>
      </ul>

      <h3 className="mt-4 text-[20px] font-semibold">제3조 (개인정보의 처리 및 보유 기간)</h3>
      <p>① 회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.</p>
      <p className="mb-2">② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.</p>
      <ul className="space-y-1">
        <li>
          <span className="font-semibold">
            1. 회원 가입 및 관리: 회원 탈퇴 시까지.
            <br />
          </span>
          <ul className="ml-6 list-[circle] space-y-1">
            <li>다만, 아래의 경우에는 해당 사유 종료 시까지 보관합니다.</li>
            <li>관계 법령 위반에 따른 수사·조사 등이 진행 중인 경우: 해당 수사·조사 종료 시까지</li>
            <li>서비스 이용에 따른 채권·채무관계 잔존 시: 해당 채권·채무관계 정산 시까지</li>
          </ul>
        </li>

        <li>
          <span className="font-semibold">2. 재화 또는 서비스 제공: 재화·서비스 공급완료 및 요금결제·정산 완료 시까지.</span>
          <ul className="ml-6 list-[circle] space-y-1">
            <li> 다만, 「전자상거래 등에서의 소비자보호에 관한 법률」 등에 따라 아래 기간 동안 보관합니다.</li>
            <li>계약 또는 청약철회 등에 관한 기록: 5년</li>
            <li>대금결제 및 재화 등의 공급에 관한 기록: 5년</li>
            <li>소비자의 불만 또는 분쟁처리에 관한 기록: 3년</li>
          </ul>
        </li>
        <li>
          <span className="font-semibold">3. 위치정보:</span> 위치정보의 이용·제공사실 확인자료는 「위치정보의 보호 및 이용 등에 관한 법률」 및 회사의 &apos;위치기반서비스
          이용약관&apos;에 따라 6개월 이상(또는 1년) 보관합니다.
        </li>
      </ul>

      <h3 className="mt-4 text-[20px] font-semibold">제4조 (개인정보의 제3자 제공)</h3>
      <p>
        회사는 정보주체의 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에
        해당하는 경우에만 개인정보를 제3자에게 제공합니다.
      </p>

      <h3 className="mt-4 text-[20px] font-semibold">제5조 (개인정보 처리의 위탁)</h3>
      <p className="mb-2">① 회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</p>
      <table className="mt-1 w-full border-collapse text-xs">
        <thead>
          <tr>
            <th className="border px-2 py-1">수탁자 (업체명)</th>
            <th className="border px-2 py-1">위탁하는 업무의 내용</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="border px-2 py-1">NAVER CLOUD PLATFORM</td>
            <td className="border px-2 py-1">클라우드 서버 운영 및 데이터 보관</td>
          </tr>
          <tr>
            <td className="border px-2 py-1">다이렉트센드</td>
            <td className="border px-2 py-1">문자메시지(SMS/LMS) 및 알림톡 발송 대행</td>
          </tr>
        </tbody>
      </table>
      <p className="mt-2 mb-2">
        ② 위탁계약 체결 시 「개인정보 보호법」 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등
        책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
      </p>
      <p className="mb-2">③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.</p>

      <h3 className="mt-4 text-[20px] font-semibold">제6조 (개인정보의 파기 절차 및 방법)</h3>
      <p className="mb-2">① 회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.</p>
      <p className="mb-2">② 개인정보 파기의 절차 및 방법은 다음과 같습니다.</p>
      <ul className="ml-4 space-y-1">
        <li>
          <span className="font-semibold">1. 파기절차:</span> 회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.
        </li>
        <li>
          <span className="font-semibold">2. 파기방법:</span> 전자적 파일 형태로 기록·저장된 개인정보는 기록을 재생할 수 없도록 영구 삭제하며, 종이 문서에 기록·저장된 개인정보는
          분쇄기로 분쇄하거나 소각하여 파기합니다.
        </li>
      </ul>

      <h3 className="mt-4 text-[20px] font-semibold">제7조 (정보주체와 법정대리인의 권리·의무 및 행사방법)</h3>
      <p className="mb-2">① 정보주체는 회사에 대해 언제든지 개인정보 열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수 있습니다.</p>
      <p className="mb-2">② 권리 행사는 회사에 대해 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며, 회사는 이에 대해 지체없이 조치하겠습니다.</p>
      <p className="mb-2">
        ③ 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수도 있습니다. 이 경우 “개인정보 처리 방법에 관한 고시(제2023-12호)” 별지 제11호 서식에 따른
        위임장을 제출하셔야 합니다.
      </p>

      <h3 className="mt-4 text-[20px] font-semibold">제8조 (개인정보의 안전성 확보조치)</h3>
      <p className="mb-2">회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>
      <ul className="ml-4 space-y-1">
        <li>
          <span className="font-semibold">1. 관리적 조치:</span> 내부관리계획 수립·시행, 정기적 직원 교육 등
        </li>
        <li>
          {' '}
          <span className="font-semibold">2. 기술적 조치:</span>개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치
        </li>
        <li>
          {' '}
          <span className="font-semibold">3. 물리적 조치:</span> 전산실, 자료보관실 등의 접근통제
        </li>
      </ul>

      <h3 className="mt-4 mb-2 text-[20px] font-semibold">제9조 (개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항)</h3>
      <p className="mb-2">① 회사는 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다.</p>
      <p className="mb-2">
        ② 쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다.
      </p>
      <ul className="mb-2 ml-4 space-y-1">
        <li>
          <span className="font-semibold"> 1. 쿠키의 사용 목적:</span> 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부 등을 파악하여
          이용자에게 최적화된 정보 제공을 위해 사용됩니다.
        </li>
        <li>
          <span className="font-semibold">2. 쿠키의 설치·운영 및 거부:</span> 웹브라우저 상단의 도구 &gt; 인터넷 옵션 &gt; 개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부할 수
          있습니다.
        </li>
        <li>
          <span className="font-semibold">3. 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.</span>
        </li>
      </ul>
      <p className="mb-2">
        ③ 모바일 앱 이용 시 단말기 식별정보(Device ID)나 위치정보가 수집될 수 있으며, 이용자는 단말기 설정 메뉴에서 이에 대한 권한을 거부하거나 철회할 수 있습니다.
      </p>

      <h3 className="mt-4 text-[20px] font-semibold">제10조 (개인정보 보호책임자 및 권익침해 구제방법)</h3>
      <p className="mb-2">
        ① 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고
        있습니다.
      </p>
      <div className="mb-2">
        <ul className="ml-5 list-disc">
          <li>
            <b>개인정보 보호책임자</b>
          </li>
        </ul>
        <ul className="ml-7 list-[circle]">
          <li>성명: 정기연</li>
          <li>직책: 상무</li>
          <li>연락처: 070-4248-6444, hanlim@hanlimce.co.kr</li>
        </ul>
      </div>
      <p className="mb-2">② 정보주체는 개인정보침해로 인한 구제를 받기 위하여 아래 기관에 분쟁해결이나 상담 등을 신청할 수 있습니다.</p>
      <ul className="ml-7 list-[circle] space-y-1">
        <li> 개인정보분쟁조정위원회: 1833-6972 (www.kopico.go.kr)</li>
        <li> 개인정보침해신고센터: 118 (privacy.kisa.or.kr)</li>
        <li> 대검찰청: 1301 (www.spo.go.kr)</li>
        <li> 경찰청: 182 (ecrm.police.go.kr)</li>
      </ul>

      <h3 className="mt-4 text-[20px] font-semibold">제11조 (개인정보 처리방침의 변경)</h3>
      <p className="mb-2">① 이 개인정보 처리방침은 2025년 11월 24일부터 적용됩니다.</p>
      <p className="mb-2">② 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.</p>
    </PolicyModalShell>
  );
};
